<template>
  <div class="card h-100 group-actions-localizable-widget">
    <div class="card-header">
      <h4 class="card-title">
        {{ widgetTitle }}
      </h4>
    </div>
    <div class="card-body">
      <div
        v-if="
          peopleSelectedAtLeastOneAction && numberOfUsersThatHaveResponded > 1
        "
        class="people-selected-actions"
      >
        <p class="text-info ml-3 d-flex align-items-center">
          <i class="bi bi-info-circle-fill fs-3 text-info me-3"></i>
          {{
            $t('widgetGroupActions.peopleSelectedActions', {
              count: peopleSelectedAtLeastOneAction,
              peopleResponded: numberOfUsersThatHaveResponded,
              percentage: percentageOfPeopleSelectedAtleastOneAction
            })
          }}
        </p>
      </div>
      <div
        v-for="categoryName in Object.keys(actionsByCategory)"
        :key="categoryName"
        class="mb-10"
      >
        <h5>
          {{ $tr(data.locales, `category.${categoryName}.title`) }}
        </h5>
        <div
          v-for="actionName in Object.keys(
            actionsByCategory[categoryName].actions
          )"
          :key="actionName"
          class="action d-flex align-items-center mb-3"
        >
          <span
            v-if="numberOfPeopleInSelectedGroup > 1"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            :title="
              $t('widgetGroupActions.tooltip.numberOfPeopleChoseActions', {
                count:
                  actionsByCategory[categoryName].actions[actionName]
                    .numberOfPeople
              })
            "
            class="badge badge-pill me-3 users-selected-action d-flex justify-content-center badge-secondary"
          >
            {{
              actionsByCategory[categoryName].actions[actionName].numberOfPeople
            }}
          </span>
          <!-- <b-badge
            v-if="numberOfPeopleInSelectedGroup > 1"
            :id="`${categoryName}-${actionName}-badge`"
            variant="secondary"
            class="badge-pill me-3 users-selected-action d-flex justify-content-center"
          >
            {{ categories[categoryName].actions[actionName].numberOfPeople }}
          </b-badge> -->
          <p class="mb-0">
            {{
              $tr(
                actionsByCategory[categoryName].actions[actionName].messages,
                'title'
              )
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonWidgetProps from '@/components/mixins/common-widget-props'
import { requestTypes } from '@/constants/request-types'
import { errorTypes } from '@/constants/error-types'

export const groupActionsLocalizableWidgetInformation = ({ colData }) => {
  return {
    requests: {
      [requestTypes.ACTIONS]: {
        params: { doneOnly: !!colData.doneOnly }
      },
      [requestTypes.CATEGORIES]: {},
      [requestTypes.TAGS]: {
        filter: {
          participation: {}
        }
      }
    }
  }
}

export const groupActionsLocalizableWidgetSkeleton = () => {
  return {
    header: {
      height: 2
    },
    body: [
      {
        cols: [{ height: 2 }]
      },
      {
        cols: [{ height: 10 }]
      }
    ]
  }
}

const groupActionsLocalizableWidget = {
  name: 'GroupActionsLocalizableWidget',
  mixins: [commonWidgetProps],
  props: {
    actions: {
      type: Object,
      default: () => {}
    },
    categories: {
      type: Object,
      default: () => {}
    },
    tags: {
      type: Object,
      default: () => {}
    },
    userIsAdminForCurrentGroupOrSuperAdmin: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (!Object.keys(this.actionsByCategory)?.length) {
      this.deregisterWidget({
        id: this.id,
        info: {
          reason: errorTypes.NOT_ENOUGH_DATA,
          hideWidgetWhenNoSurveyResults: true
        },
        groupName: this.selectedGroupName
      })
    }
  },
  computed: {
    actionsByCategory() {
      return (this.actions.actions || []).reduce((res, action) => {
        action.categories.forEach((categoryObj) => {
          const categoryName = Object.keys(categoryObj)[0]
          const { numberOfActions } = categoryObj[categoryName]
          if (!res[categoryName]) {
            res[categoryName] = { actions: {} }
          }
          res[categoryName].actions[action.actionName] = {
            ...action,
            numberOfPeople: numberOfActions
          }
        })
        return res
      }, {})
    },
    numberOfPeopleInSelectedGroup() {
      return this.tags.participation.numberOfResponses
    },
    numberOfUsersThatHaveResponded() {
      return this.tags.participation.amount_10
    },
    peopleSelectedAtLeastOneAction() {
      return this.actions.actionStats?.numberOfPeopleThatSelectedAnAction
    },
    percentageOfPeopleSelectedAtleastOneAction() {
      return this.peopleSelectedAtLeastOneAction
        ? Math.round(
            (this.peopleSelectedAtLeastOneAction /
              this.numberOfUsersThatHaveResponded) *
              100
          )
        : null
    },
    widgetTitle() {
      return this.$t('widgetGroupActions.title', {
        groupName: this.selectedGroupTitle
      })
    },
    groupActions() {
      return this.actions.actions
        .filter((action) => {
          // usually this widget only contains actions that are unique for this category
          // but this is to handle exception from that
          const categoryNames = action.categories.map((c) => Object.keys(c)[0])
          return (
            categoryNames.includes(this.data.category) &&
            action.type === 'proposal'
          )
        })
        .sort((a, b) => {
          return b.numberOfPeople - a.numberOfPeople
        })
    }
  }
}

export default groupActionsLocalizableWidget
</script>

<style scoped>
.users-selected-action {
  min-width: 35px;
}
</style>
